import { render, staticRenderFns } from "./ConsultaInventarios.vue?vue&type=template&id=0f7d38ef&"
import script from "./ConsultaInventarios.vue?vue&type=script&lang=js&"
export * from "./ConsultaInventarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports